<template>
	<div class="row">
		<div
			v-for="item in items"
			:key="item.ID"
			class="columns column3 gallery filter-item"
			:class="{
				active: filter === (item.galleryCategorie && item.galleryCategorie.header) || filter === 'showAll',
			}"
		>
			<gallery-item :item="item" />
		</div>
	</div>
</template>

<script setup>
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

defineProps({
	items: { type: Array, default: () => [] },
	filter: { type: String, default: 'showAll' },
});

onMounted(() => {
	Fancybox.bind('[data-fancybox]', {});
});
</script>

<style lang="scss" scoped>
.gallery {
	position: relative;
	padding: 0 15px 30px;
}
</style>
